import type { SerializedMeterModel } from '@enmon/commons/lib/tools';
import { useServices } from 'containers/services';
import { useQuery, type UseQueryOptions, type UseQueryResult } from 'react-query';
import { QUERY_KEYS } from 'utils/queryKeys';
import type { GetMetersByModelIdResult, MetersByMeterModelsFilterWithPagination } from '../../../lib/services';

export const useMetersByModelId = (
  modelId: SerializedMeterModel['id'] | undefined,
  filter?: MetersByMeterModelsFilterWithPagination,
  options?: UseQueryOptions<GetMetersByModelIdResult, Error>,
): UseQueryResult<GetMetersByModelIdResult> => {
  const { meterModelsApiClient } = useServices();

  return useQuery({
    queryKey: QUERY_KEYS.meterModels.meters(modelId, filter),
    queryFn: async ({ signal }) => await meterModelsApiClient.getMetersByModelId({ modelId, filter, signal }),
    enabled: Boolean(modelId),
    ...options,
  });
};
